type InsurerAuthLinks = {
  [slug: string]: {
    registerUrl: string;
    forgotPasswordUrl: string;
  };
};

/**
 * Insurer auth links.
 *
 * As of 2025-10-02, These have all be manually verified - Eliott
 * We are doing this locally instead of adding into the backend because
 * we are not sure if we will need to update/add to or remove these links in the future.
 */
export const insurerAuthLinks: InsurerAuthLinks = {
  aetna: {
    registerUrl: "https://www.aetna.com/managemyaccount/Register",
    forgotPasswordUrl: "https://www.aetna.com/managemyaccount/forgotPassword",
  },
  unitedhealthcare: {
    registerUrl: "https://www.healthsafe-id.com/rt/register/uhccom/en",
    forgotPasswordUrl: "https://www.healthsafe-id.com/rt/password/uhccom/en",
  },
  cigna: {
    registerUrl: "https://my.cigna.com/web/public/consumer/registration/intro",
    forgotPasswordUrl:
      "https://my.cigna.com/web/public/consumer/forgot/password",
  },
  anthem: {
    registerUrl:
      "https://membersecure.anthem.com/member/public/register?brand=ABCBS",
    forgotPasswordUrl:
      "https://membersecure.anthem.com/member/public/forgot-username-password?brand=ABCBS",
  },
  humana: {
    registerUrl: "https://account.humana.com/",
    forgotPasswordUrl: "https://account.humana.com/forgot-password",
  },
  "kaiser-permanentente": {
    registerUrl:
      "https://healthy.kaiserpermanente.org/register/member-registration#/info-new",
    forgotPasswordUrl:
      "https://healthy.kaiserpermanente.org/consumer-sign-on/help-signing-in",
  },
  "blue-shield-of-california": {
    registerUrl: "https://www.blueshieldca.com/memberwebapp/registration",
    forgotPasswordUrl:
      "https://www.blueshieldca.com/memberwebapp/forgot-password",
  },
  "florida-blue": {
    registerUrl: "https://registration.bcbsfl.com/ecir/public/Registration.do",
    forgotPasswordUrl:
      "https://registration.bcbsfl.com/ecir/public/MemberFPSSelect.do",
  },
  oscar: {
    registerUrl: "https://accounts.hioscar.com/account/initialize-account/",
    forgotPasswordUrl: "https://accounts.hioscar.com/account/reset-password/",
  },
  "oscar-health": {
    registerUrl: "https://accounts.hioscar.com/account/initialize-account/",
    forgotPasswordUrl: "https://accounts.hioscar.com/account/reset-password/",
  },
};
